'use es6';

import { REQUEST_PROPERTIES_BOOTSTRAP, REQUEST_PROPERTIES_BOOTSTRAP_FAIL, REQUEST_PROPERTIES_BOOTSTRAP_SUCCESS, REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID, REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_FAIL, REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_SUCCESS, SEARCH_FOR_PROPERTIES, SEARCH_FOR_PROPERTIES_FAIL, SEARCH_FOR_PROPERTIES_SUCCESS, CLEAR_SEARCH_PROPERTIES, RECEIVE_CUSTOM_OBJECT } from 'FormsUI/actions/CustomObjects';
import { NOT_REQUESTED, REQUESTED, SUCCEEDED, FAILED } from 'FormsCommonComponents/lib/RequestState';
import { addAdConsentFlattenedProperty } from 'FormsUI/utils/AdConsent';
export const initialState = {
  isLoading: false,
  showSearchResults: false,
  objectTypes: [],
  flattenedObjects: {},
  requiredProperties: {},
  objectTypeSearchResults: [],
  frequentlyUsedProperties: [],
  currentRequestingObjectType: '',
  searchQueries: {},
  SUBMISSIONS_BOOTSTRAP_REQUEST_STATE: NOT_REQUESTED,
  OBJECT_ID_REQUEST_STATE: NOT_REQUESTED,
  SEARCH_REQUEST_STATE: NOT_REQUESTED
};
import { handleRequiredProperties, handleObjectTypesMerge, flattenObjects, handleObjectTypeIdsToNameMap } from 'FormsUI/utils/CustomObjects';
export default function (state = initialState, {
  type = '',
  payload
}) {
  switch (type) {
    case REQUEST_PROPERTIES_BOOTSTRAP:
      return Object.assign({}, state, {
        isLoading: true,
        BOOTSTRAP_REQUEST_STATE: REQUESTED
      });
    case REQUEST_PROPERTIES_BOOTSTRAP_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        objectTypes: payload.objectTypes,
        frequentlyUsedProperties: payload.frequentlyUsedProperties,
        objectTypeIdsToNameMap: handleObjectTypeIdsToNameMap(payload),
        requiredProperties: handleRequiredProperties(payload.requiredProperties, payload.objectTypes),
        BOOTSTRAP_REQUEST_STATE: SUCCEEDED
      });
    case REQUEST_PROPERTIES_BOOTSTRAP_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        BOOTSTRAP_REQUEST_STATE: FAILED
      });
    case REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID:
      return Object.assign({}, state, {
        OBJECT_ID_REQUEST_STATE: REQUESTED,
        currentRequestingObjectType: payload
      });
    case REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_SUCCESS:
      return Object.assign({}, state, {
        OBJECT_ID_REQUEST_STATE: SUCCEEDED,
        objectTypes: handleObjectTypesMerge(payload, state),
        flattenedObjects: addAdConsentFlattenedProperty(flattenObjects(payload, state), state)
      });
    case REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_FAIL:
      return Object.assign({}, state, {
        OBJECT_ID_REQUEST_STATE: FAILED
      });
    case SEARCH_FOR_PROPERTIES:
      return Object.assign({}, state, {
        isLoading: true,
        showSearchResults: true,
        SEARCH_REQUEST_STATE: REQUESTED
      });
    case SEARCH_FOR_PROPERTIES_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        showSearchResults: true,
        SEARCH_REQUEST_STATE: SUCCEEDED,
        objectTypeSearchResults: payload.data,
        searchQueries: Object.assign({}, state.searchQueries, {
          [payload.searchTerm]: payload.data
        })
      });
    case SEARCH_FOR_PROPERTIES_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        showSearchResults: false,
        SEARCH_REQUEST_STATE: FAILED
      });
    case CLEAR_SEARCH_PROPERTIES:
      return Object.assign({}, state, {
        showSearchResults: false,
        objectTypeSearchResults: []
      });
    case RECEIVE_CUSTOM_OBJECT:
      {
        return Object.assign({}, state, {
          customObjects: payload.customObjects
        });
      }
    default:
      return state;
  }
}